// src/services/wishlistService.js
import axios from "axios";

const API = "http://localhost:8080/api/wishlist";

export const toggleWishlist = async (userId, tripSlug) => {
  const response = await axios.post(`${API}/toggle`, null, {
    params: { userId, tripSlug },
  });
  return response.data;
};

export const fetchWishlist = async (userId) => {
  const response = await axios.get(`${API}/${userId}`);
  return response.data; // list of slugs
};
